import type { ViewSettings } from "@ext/markdown/elements/view/models/ViewSettings";
import type { ViewSurfaceVariant } from "@ext/markdown/elements/view/models/ViewSurfaceVariant";
import Kanban from "@ext/markdown/elements/view/render/components/Displays/Kanban";
import List from "@ext/markdown/elements/view/render/components/Displays/List";
import Table from "@ext/markdown/elements/view/render/components/Displays/Table";
import TableNew from "@ext/markdown/elements/view/render/components/Displays/TableNew";
import type { ViewRenderGroup } from "@ext/properties/models";
import { Display } from "@ext/properties/models/display";
import type { ReactNode } from "react";

/** Every display is handed the same fetched view; each one reads the part of it that it draws. */
export type ViewDisplayProps = Omit<ViewSettings, "display"> & {
	content: ViewRenderGroup[];
	disabled: boolean;
	className?: string;
	commentId?: string;
	isPrint?: boolean;
	updateArticle?: (articlePath: string, property: string, value: string, isDelete?: boolean) => void;
};

type ViewDisplay = (props: ViewDisplayProps) => ReactNode;

const ARTICLE_DISPLAYS: Record<Display, ViewDisplay> = {
	[Display.List]: List,
	[Display.Kanban]: Kanban,
	[Display.Table]: Table,
};

// The report panel draws a table with the ui-kit one. It is the same display as far as the document
// is concerned — `display="Table"` either way — so nothing a newer version writes reaches an older one.
const PANEL_DISPLAYS: Record<Display, ViewDisplay> = { ...ARTICLE_DISPLAYS, [Display.Table]: TableNew };

export const getDisplayComponent = (display: Display, surface: ViewSurfaceVariant): ViewDisplay => {
	const displays = surface === "panel" ? PANEL_DISPLAYS : ARTICLE_DISPLAYS;
	return displays[display] ?? displays[Display.List];
};
